import React, { useState, useRef, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";

import { connect } from "react-redux";
import Paper from "@material-ui/core/Paper";
import axios from "axios";
import Loader from "../Loader/Loader";
import DataTable from "./components/DataTable";
import { Typography, Drawer } from '@material-ui/core';
import PassengerCard from "./components/passengerCard";
import TripType from "./components/tripType";
import JourneyClass from "./components/journeyClass";
import OriginDestination from "./components/OriginDestination";
import JourneyDate from "./components/journeyDate";
import flightBanner from "../../assets/img/flight-banner.png";
import IconSearch from "@material-ui/icons/Search";
import IconBack from '@material-ui/icons/ArrowBack'
import PopularDestinations from "./PopularDestinations";
import "./index.css";
import { momentToHrs } from "../../helpers/date.helper";
import { addToHistory } from "./utils/SearchHistory";
import RecentSearches from "./components/RecentSearches";
import FlyDuration from "./components/filters/FlyDuration";
import SortBy from "./components/filters/SortBy";
import SelectedCabins from "./components/filters/SelectedCabins";
import PriceRange from "./components/filters/PriceRange.js";
import DepartureTimeRange from "./components/filters/TimeRange";
import ArrivalTimeRange from "./components/filters/TimeRange";
import Baggages from './components/filters/Baggages'
import MaxStops from './components/filters/MaxStops'
import moment from "moment";
import CurrencySelector from './CurrencySelector'
import Footer from './components/footer'
import Calendar from './components/Calendar'
import PriceGraph from './components/PriceGraph'

/////////////////////////////////////////////////////////

import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Button from '@mui/material/Button';
//////////////////////////////////////////////////

import { getVendorDetails } from "../../store/actions/vendor/Vendor";
import {
  getCommission
} from "../../store/actions/admin/Admin";
import TravelMenu from "../User/Header/TravelMenu";
import FlightSearch from "./FlightSearch/FlightSearch";
import FlightResults from "./FlightResults";

const SESSION_KEY = "SESSION_KEY";
const useStyles = makeStyles((theme) => ({
  paper: {
    height: 140,
    width: 100,
  },
  drawer: {
    background: 'red'
  },
  control: {
    padding: "4%",
    [theme.breakpoints.down("sm")]: {
      padding: "4%",
    },
  },
  main: {
    paddingTop: "30%",
    // backgroundColor: "var(--darker)",  
    // [theme.breakpoints.down("sm")]: {
    //   paddingTop: "18%",
    // },

  },

  main2: {
    paddingTop: "8%",

    // backgroundColor: "var(--darker)",  
    [theme.breakpoints.down("sm")]: {
      paddingLeft: '2%',
      paddingRight: '2%',
      paddingTop: "21%",
    },
    [theme.breakpoints.down("md")]: {
      paddingLeft: '2%',
      paddingRight: '2%',
      paddingTop: "14%",
    },
  },
  container: {
    backgroundColor: "var(--white)",
    borderRadius: 5
  },
  formSelect: {
    fontSize: ".875rem",
    padding: "0.5%",
  },
  flightBG: {
    backgroundColor: "var(--backgroundcolor)",
    [theme.breakpoints.down("sm")]: {
      height: '80px',
      marginTop: '62px',
      marginBottom: '0px',
    },
    backgroundSize: '100% 100%',
  },
}));

function Airports(props) {
  const classes = useStyles();

  const searchFlights = function() {

    const sessionData = {};
    if (!this.departureAirport || !this.arrivalAirport || !this.selectedDepartureDate) {
      return;
    }
    if (this.journeyType === "Return" && !this.selectedArrivalDate) {
      return;
    }

    this.setDrawerOpen(false);
    let RecentSearches = addToHistory({
      start: { code: this.departureAirport, name: this.departureAirportName },
      end: { code: this.arrivalAirport, name: this.arrivalAirportName },
      journey_type: this.journeyType,
      arrivalDate: this.selectedArrivalDate,
      departureDate: this.selectedDepartureDate,
      adults: this.adults,
      kids: this.kids,
      infants: this.infants,
      flightClass: this.flightClass
    });

    const { dispatch } = props;
    dispatch({ type: "SET_SEARCH_HISTORY", data: RecentSearches });

    this.setLoading(true);

    let queryParam = `/flights/airlines-offer?departureAirport=${this.departureAirport}&departureAirportName=${this.departureAirportName}&selectedDepartureDate=${this.selectedDepartureDate}&arrivalAirport=${this.arrivalAirport}&arrivalAirportName=${this.arrivalAirportName}&adults=${this.adults}&kids=${this.kids}&infants=${this.infants}&journeyType=${this.journeyType}`;

    sessionData["departureAirport"] = this.departureAirport;
    sessionData["departureAirportName"] = this.departureAirportName;
    sessionData["selectedDepartureDate"] = this.selectedDepartureDate;
    sessionData["arrivalAirport"] = this.arrivalAirport;
    sessionData["arrivalAirportName"] = this.arrivalAirportName;
    sessionData["adults"] = this.adults;
    sessionData["kids"] = this.kids;
    sessionData["infants"] = this.infants;

    if (this.sortBy) {
      queryParam += `&sortBy=${this.sortBy}`;
      sessionData["sortBy"] = this.sortBy;
    }
    // if (selectedCurrency) {
    //   queryParam += `&currency=${selectedCurrency}`
    //   priceSearchQuery+= `&currency=${selectedCurrency}`
    // }
    let currency = props.currency;
    // if (!currency) {
    //   currency=localStorage.getItem('selectedCurrency')
    // }
    if (currency)
      queryParam += `&currency=${currency}`

    if (this.useStops && this.stops != -1 && this.stops != 2) {
      queryParam += `&stops=${this.stops}`;
      sessionData["stops"] = this.stops;
    }
    if (this.flightClass && this.flightClass !== "Any") {
      queryParam += `&flightClass=${this.flightClass}`;
      sessionData["flightClass"] = this.flightClass;
    }

    if (this.journeyType === "Return" && this.selectedArrivalDate) {
      queryParam += `&selectedArrivalDate=${this.selectedArrivalDate}`;
      sessionData["selectedArrivalDate"] = this.selectedArrivalDate;
    }

    if (this.useflyDuration && this.lyDuration != 0) {
      queryParam += `&flyDuration=${this.flyDuration}`;
      sessionData["flyDuration"] = this.flyDuration;
    }
    if (
      this.usePriceRange &&
      this.priceRange &&
      this.priceRange[0] >= 0 &&
      this.priceRange[1] != 0
    ) {
      queryParam += `&price_from=${this.priceRange[0]}&price_to=${this.priceRange[1]}`;
      // sessionData["priceRange"] = priceRange;
    }
    if (
      this.useDepartureTimeRange &&
      this.departureTimeRange &&
      this.departureTimeRange.min != "" &&
      this.departureTimeRange.max != ""
    ) {
      queryParam += `&dtime_from=${momentToHrs(
        this.departureTimeRange.min
      )}&dtime_from=${momentToHrs(this.departureTimeRange.max)}`;
      sessionData["departureTimeRange"] = this.departureTimeRange;
    }


    if (
      this.useArrivalTimeRange &&
      this.arrivalTimeRange &&
      this.arrivalTimeRange.min != "" &&
      this.arrivalTimeRange.max != ""
    ) {
      queryParam += `&atime_from=${momentToHrs(
        this.arrivalTimeRange.min
      )}&atime_from=${momentToHrs(this.arrivalTimeRange.max)}`;
      sessionData["arrivalTimeRange"] = this.arrivalTimeRange;
    }
    if (this.useBaggage && this.baggage) {
      if (this.baggage.hand_bag != "0") { queryParam += `&adult_hand_bag=${this.baggage.hand_bag}` }

      if (this.baggage.hold_bag != "0") {
        queryParam += `&adult_hold_bag=${this.baggage.hold_bag}`;
      }
      sessionData["baggage"] = this.baggage;
    }
    props.history.push(queryParam)

    sessionStorage.setItem(SESSION_KEY, JSON.stringify(sessionData));

    this.setLoading(false);
  };

  return (
    <>
      <div style={{ backgroundColor: 'var(--backgroundcolor)', color: 'var(--backgroundcolor)' }}>
        <TravelMenu activeIndex={1}/>
        <div>
          <div className={`${classes.main}`} style={{ paddingTop: 0 }}>
            <div
              className={`container `}
              style={{ marginBottom: 70, marginTop: 50, padding: "15px" }}
            >
              <Typography
                variant="h4"
                style={{ color: "var(--darker)", textTransform: "capitalize", textAlign: 'left', fontWeight: '500' }}
              >
                Discover the cheap hidden flights
              </Typography>

              <Typography
                component="p"
                style={{ color: "var(--darker)", textTransform: "capitalize", color: 'var(--lighttextcolor)',textAlign: 'left' }}
              >
                We hack the system you fly for Less
              </Typography>
            </div>
          </div>
        </div>
        <FlightResults page={1} onFlightSearch={searchFlights} history={props.history}/> 
      <Footer />
      </div>
    </>
  );
}

const mapStateWithProps = (state) => {
  let commissionType = ""
  let commissionValue = 0
  if (state.vendor && state.vendor.vendorDetail) {
    commissionType = state.vendor.vendorDetail.commissionType;
    commissionValue = state.vendor.vendorDetail.commissionValue;
  }
  let adminCommissionType = "Fixed"
  let adminCommissionValue = 0
  if (state.admin && state.admin.commission && state.admin.commission.commissionType) {
    adminCommissionType = state.admin.commission.commissionType;
    adminCommissionValue = state.admin.commission.commissionValue;
  }
  return {
    searches: state.searchHistory.searches,
    currency: state.flight.currency ? state.flight.currency : "",
    commissionValue: commissionValue,
    commissionType: commissionType,
    adminCommissionValue: adminCommissionValue,
    adminCommissionType: adminCommissionType
  }
};



export default React.memo(connect(mapStateWithProps)(Airports));
